import { render, staticRenderFns } from "./liabilityInsurance.vue?vue&type=template&id=40791f3a&"
import script from "./liabilityInsurance.vue?vue&type=script&lang=js&"
export * from "./liabilityInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40791f3a')) {
      api.createRecord('40791f3a', component.options)
    } else {
      api.reload('40791f3a', component.options)
    }
    module.hot.accept("./liabilityInsurance.vue?vue&type=template&id=40791f3a&", function () {
      api.rerender('40791f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Insurance/liabilityInsurance.vue"
export default component.exports